import { render } from "./Whatsapp.vue?vue&type=template&id=f0404322"
import script from "./Whatsapp.vue?vue&type=script&lang=js"
export * from "./Whatsapp.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__